import { render, staticRenderFns } from "./questionContent.vue?vue&type=template&id=22a2ccfc&scoped=true&"
import script from "./questionContent.vue?vue&type=script&lang=js&"
export * from "./questionContent.vue?vue&type=script&lang=js&"
import style0 from "./questionContent.vue?vue&type=style&index=0&id=22a2ccfc&prod&lang=scss&"
import style1 from "./questionContent.vue?vue&type=style&index=1&id=22a2ccfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a2ccfc",
  null
  
)

export default component.exports